<template>
    <div class="d-ins">
        <p>An eyewitness identified the taxi as a blue cab.</p>
        <div>
            <b-img src="@/assets/img/itwasblue.jpg" class="center-block" fluid alt="Taxi Hit and Run"></b-img>
        </div>
    </div>
</template>
<script>
export default {
  components: {
  }
}
</script>
